// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".action-container[data-v-2c8c52e6]{display:flex;justify-content:right}.dialog-container[data-v-2c8c52e6]{padding:1rem}.error-text[data-v-2c8c52e6]{font-size:1rem}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
